import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import get from 'lodash.get';
import { article as ArticlePropType } from 'lib/CustomPropTypes';
import SignupInput from '../SignupInput';
import verticalLogic from '../verticalLogic';

const mapStateToProps = ({ shared, article }, { vertical }) => ({
  vertical: vertical || shared.vertical,
  article: get(article, 'content[0]') || null,
});

/**
 * Wrapper to configure titles and auto-hide newsletter signup. Showing and hiding of this component
 * is managed via Conductrics. https://conductrics.com/
 */
const NewsletterSignupWrapper = ({ vertical, article }, { amp = false }) => {
  if (amp) return null;

  const {
    title, description, newsletterIdVars, stKey,
  } = verticalLogic(vertical, article);

  return (
    <div className="newsletter-signup__container">
      {title && <p className="newsletter-signup__title">{title}</p>}
      {description && <div className="newsletter-signup__descr">{description}</div>}
      <SignupInput
        newsletterId={newsletterIdVars}
        sitekey={stKey}
        vertical={vertical}
      />
    </div>
  );
};

NewsletterSignupWrapper.propTypes = {
  article: ArticlePropType,
  vertical: PropTypes.string.isRequired,
};

NewsletterSignupWrapper.defaultProps = {
  article: {},
};

NewsletterSignupWrapper.contextTypes = {
  amp: PropTypes.bool,
};

export default connect(mapStateToProps)(NewsletterSignupWrapper);
